"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedLogger = void 0;
const tracing_1 = require("../tracing");
class ScopedLogger {
    constructor(config, traceContext) {
        this.$name = 'scoped-logger';
        this._entries = [];
        this._hasError = false;
        this._isDebugEnabled = false;
        this._isDebugEnabled = config.isDebugEnabled;
        this._traceId = traceContext.traceId;
        this._requestId = traceContext.requestId;
    }
    debug(obj) {
        this._entries.unshift({
            type: "debug",
            args: Object.assign({ timestamp: Date.now() }, obj)
        });
    }
    error(obj) {
        this._entries.unshift({
            type: "error",
            args: Object.assign({ timestamp: Date.now() }, obj)
        });
        this._hasError = true;
    }
    info(obj) {
        this._entries.unshift({
            type: "info",
            args: Object.assign({ timestamp: Date.now() }, obj)
        });
    }
    fork() {
        return new ScopedLogger({ isDebugEnabled: this._isDebugEnabled }, tracing_1.TraceContext.fromTraceIdAndRequestId(this._traceId, this._requestId));
    }
    mergeIn(logger, areLogsAggregated) {
        var _a;
        if (areLogsAggregated) {
            if (logger._hasError) {
                const error = logger._entries.find(e => e.type === "error");
                const trace = logger._entries.reverse().map(e => e.args);
                const lastEntry = trace[logger._entries.length - 1];
                if (lastEntry) {
                    this._entries.unshift({
                        type: "error",
                        args: {
                            location: lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.location,
                            error: (_a = error === null || error === void 0 ? void 0 : error.args) === null || _a === void 0 ? void 0 : _a.error,
                            timestamp: lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.timestamp,
                            trace: JSON.stringify(trace)
                        }
                    });
                }
            }
            else {
                const traceEntries = logger._entries
                    .filter(e => e.type === "info" || (this._isDebugEnabled && e.type === 'debug'))
                    .reverse();
                const trace = traceEntries.map(e => e.args);
                const lastEntry = trace[trace.length - 1];
                if (lastEntry) {
                    this._entries.unshift({
                        type: "info",
                        args: {
                            location: lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.location,
                            timestamp: lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.timestamp,
                            trace: JSON.stringify(trace)
                        }
                    });
                }
            }
        }
        else {
            this._entries.unshift(...logger._entries);
        }
    }
    print(logger, areLogsAggregated) {
        if (areLogsAggregated) {
            const logs = this.toLog();
            if (logs) {
                if (this._hasError) {
                    logger.error(logs);
                }
                else {
                    logger.info(logs);
                }
            }
        }
        else {
            const logs = this.toLogs();
            for (const log of logs) {
                switch (log.type) {
                    case "error":
                        logger.error(log);
                        break;
                    case "debug":
                        logger.debug(log);
                        break;
                    default:
                        logger.info(log);
                        break;
                }
            }
        }
    }
    toLog() {
        var _a;
        if (this._hasError) {
            const error = this._entries.find(e => e.type === "error");
            const trace = this._entries.reverse().map(e => e.args);
            const lastEntry = trace[this._entries.length - 1];
            return {
                traceId: this._traceId,
                requestId: this._requestId,
                location: (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.location) || '<unknown>',
                error: (_a = error === null || error === void 0 ? void 0 : error.args) === null || _a === void 0 ? void 0 : _a.error,
                timestamp: (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.timestamp) || Date.now(),
                trace: JSON.stringify(trace)
            };
        }
        else {
            const traceEntries = this._entries
                .filter(e => e.type === "info" || (this._isDebugEnabled && e.type === 'debug'))
                .reverse();
            const trace = traceEntries.map(e => e.args);
            const lastEntry = trace[trace.length - 1];
            if (lastEntry) {
                return {
                    traceId: this._traceId,
                    requestId: this._requestId,
                    location: lastEntry.location || '<unknown>',
                    timestamp: lastEntry.timestamp || Date.now(),
                    trace: JSON.stringify(trace)
                };
            }
            else {
                return null;
            }
        }
    }
    toLogs() {
        if (this._hasError) {
            const logs = this._entries.reverse().map(e => {
                const log = Object.assign(Object.assign({}, e.args), { type: e.type, location: e.args.location || '<unknown>', traceId: this._traceId, requestId: this._requestId });
                return log;
            });
            return logs;
        }
        else {
            const relevantEntries = this._entries
                .filter(e => e.type === "info" || (this._isDebugEnabled && e.type === 'debug'))
                .reverse();
            const logs = relevantEntries.map(e => {
                const log = Object.assign(Object.assign({}, e.args), { type: e.type, location: e.args.location || '<unknown>', traceId: this._traceId, requestId: this._requestId });
                return log;
            });
            return logs;
        }
    }
}
exports.ScopedLogger = ScopedLogger;
//# sourceMappingURL=scoped-logger.js.map